import { errorHandler } from '@appsignal/vue';
import appsignal from '@cta/shared/appsignal';
import { createApp } from 'vue';

const AppBoot = {
  start(appType, register = null) {
    document.addEventListener('DOMContentLoaded', () => {
      const appElement = document.getElementById('app');
      if (!appElement) return;

      const params = Object.entries(appElement.dataset).reduce((accumulator, [key, value]) => {
        accumulator[key] = JSON.parse(value);
        return accumulator;
      }, {});

      if (register) register(params);

      const app = createApp(appType, params);
      app.config.errorHandler = errorHandler(appsignal, app);
      app.mount(appElement);
    });
  },
};

export default AppBoot;
